<!--
 * @Description: 
 * @Autor: 
 * @Date: 2021-06-02 10:55:43
 * @LastEditors: lzw
 * @LastEditTime: 2021-06-10 15:55:33
 * @FilePath: \燃气B端\src\components\modals\editrecordmodal.vue
-->

<template>
  <a-modal
    :visible="visible"
    :width="650"
    title=""
    ok-text="确认"
    cancel-text="取消"
    centered
    @cancel="hideModal"
    @ok="handleSubmit"
  >
    <div class="table-box">
      <div class="table-box-row">
        <span class="key">IMEI码</span>
        <span class="value">{{ checkData.imei || "--" }}</span>
      </div>
      <div class="table-box-row">
        <span class="key">区域名称</span>
        <span class="value">{{ checkData.areaName }}</span>
        <span class="key">设备类型</span>
        <span class="value">
          {{ activeKey == 4 ? deviceType : checkData.alarmTypeName }}
        </span>
      </div>
      <div class="table-box-row">
        <span class="key">事件类型</span>
        <span class="value">{{ alarmEventType }}</span>
        <span class="key">发生时间</span>
        <span class="value">{{ checkData.createTime }}</span>
      </div>
      <div class="table-box-row">
        <span class="key">{{ activeKey == 1 ? "气体浓度1" : "气体浓度" }}</span
        ><span class="value">{{
          activeKey == 1
            ? `${checkData.gasSpecies1 || "--"}:${
                checkData.concentration1 || "--"
              } ${checkData.unit1 || "--"}`
            : `${checkData.gasSpecies || "--"}:${
                checkData.concentration || "--"
              } ${checkData.targetUnit || "--"}`
        }}</span>
        <span class="key" v-if="activeKey == 1">气体浓度2</span>
        <span class="value" v-if="activeKey == 1">
          {{ checkData.gasSpecies2 || "--" }}:
          {{ checkData.concentration2 || "--" }}
          {{ checkData.unit2 || "--" }}
        </span>
      </div>
      <div class="table-box-row">
        <span class="key">安装位置</span>
        <span class="value">{{ checkData.mountingPosition || "--" }}</span>
      </div>
      <div v-if="visible" class="table-box-row">
        <span class="key">清除理由</span>
        <span class="value">
          <a-form layout="inline" :form="form" @submit="handleSubmit">
            <a-form-item>
              <a-radio-group
                :options="reasons"
                v-decorator="[
                  'clearReason',
                  { rules: [{ required: true, message: '理由不能为空' }] },
                ]"
                @change="onChange"
              />
            </a-form-item>
          </a-form>
        </span>
      </div>
    </div>
  </a-modal>
</template>

<script>
import monitorType from "../../views/business/monitor/monitorType";
export default {
  data() {
    return {
      defaultValue: "1",
      form: this.$form.createForm(this),
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    checkData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    activeKey: {
      // type: String,
      default: 0,
    },
  },
  computed: {
    alarmEventType() {
      // let arr = monitorType.householdEvent;
      let arr =
        this.activeKey == 0
          ? monitorType.commerceEvent
          : this.activeKey == 4
          ? monitorType.dvcEvent
          : monitorType.householdEvent;
      let index = arr.findIndex((item) => {
        return (
          item.value ==
          (this.activeKey == 4
            ? this.checkData.eventType
            : this.checkData.alarmEventType)
        );
      });
      return index > -1 ? `${arr[index].name}` : "--";
    },
    reasons() {
      return monitorType.clearReasonList;
    },
    deviceType() {
      const arr = monitorType.deviceType.filter(
        (item) => item.id == this.checkData.dvcType
      );
      return arr && arr.length ? arr[0].name : "--";
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.form.resetFields();
        this.defaultValue = this.checkData.clearReason;
      }
    },
  },
  methods: {
    hideModal() {
      // this.visible = false;
      // let param = { clearReason: this.value, password: this.password };
      this.$emit("onEditHide");
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit("onEditOk", this.defaultValue);
        }
      });
    },
    /* onOk() {
      this.$emit("onEditOk", this.defaultValue);
    }, */
    onChange(e) {
      console.log("radio checked", e.target.value);
      this.defaultValue = e.target.value;
    },
  },
};
</script>

<style scoped lang="less">
.table-box {
  margin-top: 30px;
}
.table-box-row {
  display: flex;
  line-height: 35px;
  // align-items: center;
  color: rgb(75, 75, 75);
  .key {
    width: 120px;
    text-align: center;
    border: 1px #909090 solid;
    background-color: #e2e2e2;
    margin-right: -1px;
    margin-bottom: -1px;
  }
  .value {
    flex: 1;
    padding: 0 10px;
    border: 1px #909090 solid;
    margin-right: -1px;
    margin-bottom: -1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/editrecordmodal.vue